import { render, staticRenderFns } from "./ed-content-item.vue?vue&type=template&id=0713a3a8&scoped=true&"
import script from "./ed-content-item.ts?vue&type=script&lang=ts&"
export * from "./ed-content-item.ts?vue&type=script&lang=ts&"
import style0 from "./ed-content-item.scss?vue&type=style&index=0&id=0713a3a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0713a3a8",
  null
  
)

export default component.exports